document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('BackToTop');

  if (!button) return;

  const showAfter = Number.parseInt(
    button.dataset.showAfter || '300',
    10
  );

  const stickyGap = Number.parseInt(
    button.dataset.stickyGap || '16',
    10
  );

  /*
   * 記住 Back to Top 原本所在位置。
   * 當 Sticky ATC 消失或轉回桌面版時，
   * 按鈕會自動放回原位。
   */
  const originalPlaceholder = document.createComment(
    'BackToTop original position'
  );

  button.parentNode.insertBefore(originalPlaceholder, button);

  let ticking = false;

  function getNumericVariable(variableName, fallback) {
    const value = getComputedStyle(button)
      .getPropertyValue(variableName)
      .trim();

    const number = Number.parseFloat(value);

    return Number.isFinite(number) ? number : fallback;
  }

  function getDefaultPosition() {
    const isMobile = window.innerWidth < 750;

    return {
      bottom: isMobile
        ? getNumericVariable('--back-to-top-bottom-mobile', 16)
        : getNumericVariable('--back-to-top-bottom-desktop', 24),

      right: isMobile
        ? getNumericVariable('--back-to-top-right-mobile', 16)
        : getNumericVariable('--back-to-top-right-desktop', 24),

      size: getNumericVariable('--back-to-top-size', 46)
    };
  }

  function isVisible(element) {
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number.parseFloat(style.opacity || '1') > 0 &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function findBottomObstruction(defaultPosition) {
    const x =
      window.innerWidth -
      defaultPosition.right -
      defaultPosition.size / 2;

    const y =
      window.innerHeight -
      defaultPosition.bottom -
      defaultPosition.size / 2;

    const elements = document.elementsFromPoint(x, y);
    const candidates = new Set();

    elements.forEach((element) => {
      let current = element;

      while (current && current !== document.body) {
        if (
          current !== button &&
          !button.contains(current) &&
          !current.contains(button)
        ) {
          candidates.add(current);
        }

        current = current.parentElement;
      }
    });

    let obstructionHeight = 0;

    candidates.forEach((element) => {
      if (!isVisible(element)) return;

      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();

      const isFixedToViewport =
        style.position === 'fixed' ||
        style.position === 'sticky';

      const touchesViewportBottom =
        rect.bottom >= window.innerHeight - 2 &&
        rect.top < window.innerHeight;

      const overlapsButtonHorizontally =
        rect.left < x + defaultPosition.size / 2 &&
        rect.right > x - defaultPosition.size / 2;

      if (
        isFixedToViewport &&
        touchesViewportBottom &&
        overlapsButtonHorizontally
      ) {
        obstructionHeight = Math.max(
          obstructionHeight,
          window.innerHeight - rect.top
        );
      }
    });

    return obstructionHeight;
  }

  function attachToSticky(stickyBar) {
    if (button.parentElement !== stickyBar) {
      stickyBar.appendChild(button);
    }

    button.classList.add('is-attached-to-sticky');

    /*
     * 清除舊 JS 寫入的 inline bottom，
     * 讓剛才加入的 CSS 接管位置。
     */
    button.style.bottom = '';
  }

  function restoreOriginalPosition(defaultBottom) {
    button.classList.remove('is-attached-to-sticky');

    if (
      originalPlaceholder.parentNode &&
      button.previousSibling !== originalPlaceholder
    ) {
      originalPlaceholder.parentNode.insertBefore(
        button,
        originalPlaceholder.nextSibling
      );
    }

    button.style.bottom = `${defaultBottom}px`;
  }

  function updateButton() {
    const defaultPosition = getDefaultPosition();
    const isMobile = window.innerWidth < 750;

    if (window.scrollY > showAfter) {
      button.classList.add('is-visible');
    } else {
      button.classList.remove('is-visible');
    }

    /*
     * 手機版：
     * Sticky ATC 出現時，把按鈕直接放到 Sticky ATC 裏面。
     */
    if (isMobile) {
      const stickyBar = document.querySelector(
        '.sticky-atc.is-visible'
      );

      if (stickyBar && isVisible(stickyBar)) {
        attachToSticky(stickyBar);
      } else {
        restoreOriginalPosition(defaultPosition.bottom);
      }

      return;
    }

    /*
     * 桌面版：
     * 先確保按鈕已放回原位，
     * 然後保留原本正常運作的 obstruction 邏輯。
     */
    restoreOriginalPosition(defaultPosition.bottom);

    const obstructionHeight =
      findBottomObstruction(defaultPosition);

    if (obstructionHeight > 0) {
      button.style.bottom =
        `${defaultPosition.bottom +
          obstructionHeight +
          stickyGap}px`;
    }
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(() => {
      updateButton();
      ticking = false;
    });
  }

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
        ? 'auto'
        : 'smooth'
    });
  });

  window.addEventListener('scroll', requestUpdate, {
    passive: true
  });

  window.addEventListener('resize', requestUpdate);
  window.visualViewport?.addEventListener(
    'resize',
    requestUpdate
  );

  const observer = new MutationObserver(requestUpdate);

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'style', 'hidden']
  });

  updateButton();
});